/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ClosedCaption = [
  ["path", { d: "M10 9.17a3 3 0 1 0 0 5.66" }],
  ["path", { d: "M17 9.17a3 3 0 1 0 0 5.66" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }]
];

export { ClosedCaption as default };
//# sourceMappingURL=closed-caption.js.map
